"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "breakpoint", {
  enumerable: true,
  get: function get() {
    return _breakpoints.breakpoint;
  }
});
Object.defineProperty(exports, "breakpointAndDesktop", {
  enumerable: true,
  get: function get() {
    return _breakpoints.breakpointAndDesktop;
  }
});

var _breakpoints = require("./breakpoints");